/* Disabled for now
import styled from "styled-components";

const Wrapper = styled.div<{
  type: string;
  $hideOnWidth: number;
  $showOnWidth: number;
}>`
  background: var(--border-color);
  width: ${(props) => (props.type === "leaderboard" ? "728px" : "300px")};
  height: ${(props) => (props.type === "leaderboard" ? "90px" : "250px")};
  color: var(--bs-body-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem auto 0 auto;

  ${(props) =>
    props.$hideOnWidth > 0
      ? `@media (max-width: ${props.$hideOnWidth - 1}px) { display: none; }`
      : ""}

  ${(props) =>
    props.$showOnWidth > 0
      ? `@media (max-width: ${props.$showOnWidth}px) { display: none; }`
      : ""}
`;
*/

interface GoogleAdProps {
  hideOnWidth?: number;
  showOnWidth?: number;
  type?: "leaderboard" | "medium-rectangle";
}

const GoogleAd = (props: GoogleAdProps) => {
  return null;
  /* Disabled for now
  const { type = "leaderboard", hideOnWidth = 0, showOnWidth = 0 } = props;

  return (
    <Wrapper type={type} $hideOnWidth={hideOnWidth} $showOnWidth={showOnWidth}>
      Google Ad
    </Wrapper>
  );
  */
};

export default GoogleAd;
